import { Box, Button, ButtonGroup, Typography, useRouter, useTheme } from '@forgeglobal/design-framework'
import { Routes } from 'util/Routes'
import { SegmentTable } from 'components/segments/SegmentTable'
import { useAppDataQuery, useSegmentQueriesQuery } from 'graphql/bindings/AdminBindings'
import React, { Fragment, useState } from 'react'

export const Segments: React.FC = () => {
  const { spacing } = useTheme()
  const { history } = useRouter()
  const { data: segmentData } = useSegmentQueriesQuery()
  const { data: userData } = useAppDataQuery()
  const [filter, setFilter] = useState('all')

  const currentUserId = userData?.currentAdmin.id
  const segments = segmentData?.segmentQueries ?? []
  const handleChange = (event: React.MouseEvent<HTMLElement>, value: string) => {
    setFilter(value)
  }

  const handleClick = () => {
    history.push(Routes.segmentForm())
  }

  const filteredSegments =
    filter === 'all' ? segments : segments.filter(segment => segment.created_by.id === currentUserId)

  return (
    <Fragment>
      <Box p={3} pt={4}>
        <Typography variant="h4" color="secondary" style={{ textTransform: 'none' }}>
          Segments
        </Typography>
        <Box display="flex" justifyContent="flex-end">
          <Button size="small" color="primary" style={{ marginRight: spacing(4) }} onClick={handleClick}>
            Create segment
          </Button>
          <ButtonGroup
            onChange={handleChange}
            value={filter}
            options={[
              { label: 'All', value: 'all' },
              { label: 'Created by me', value: 'mine' },
            ]}
            size={'large'}
            exclusive={true}
          />
        </Box>
        <SegmentTable segments={filteredSegments} />
      </Box>
    </Fragment>
  )
}
